<header class="header">
    <div class="content-container">
        <a title="Home" [href]="home | translate" class="site-logo" rel="home"></a>
        <dmv-pub-language-selector class="language"></dmv-pub-language-selector>
    </div>
    <nav class="breadcrumb section--default" [attr.aria-expanded]="expanded$ | async" aria-labelledby="system-breadcrumb--default">
        <div class="content-container">
            <h2 id="system-breadcrumb--default" class="visually-hidden">Breadcrumb</h2>
            <ol class="no-style">
                <ng-container *ngFor="let crumb of crumbs; let i = index">
                    <li *ngIf="i === crumbs.length - 1 && (expanded$ | async) === false"  class="expandable">
                        <a href="#" [attr.aria-expanded]="expanded$ | async" [title]="'Core.Crumbs.Expand' | translate" (click)="expandCrumbs($event)">...</a>
                    </li>
                    <li>
                        <a [href]="crumb.url | translate" [translate]="crumb.text"></a>
                    </li>
                </ng-container>
                <li><span translate>Site.Title</span></li>
            </ol>
        </div>
    </nav>
    <div class="region region-highlighted" *ngIf="displayServiceUnavailableTekst">
        <div class="block block-dg-crisis block-dg-crisis-communication">
            <div class="dg-crisis-block dg-crisis-block--type-front">
                <section class="crisis-communication__wrapper">
                    <div class="crisis-communication" role="alert">
                        <i aria-hidden="true" class="icon-exclamation"></i>
                        <div class="crisis-communication__content">
                            <h2 translate>Core.Header.Onbeschikbaar.Title</h2>
                            <div [innerHTML]="displayServiceUnavailableTekst"></div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</header>
